export const CLOSE_RESOLUTION_REASONS = [
  { value: 'resolved_fixed', label: 'Resolved / Fixed' },
  { value: 'hardware_replaced', label: 'Hardware Replaced' },
  { value: 'not_reproducible', label: 'Not Reproducible' },
  { value: 'duplicate', label: 'Duplicate' },
  { value: 'no_longer_needed', label: 'No Longer Needed' },
  { value: 'other', label: 'Other' },
] as const;

export const CANCEL_RESOLUTION_REASONS = [
  { value: 'not_reproducible', label: 'Not Reproducible' },
  { value: 'duplicate', label: 'Duplicate' },
  { value: 'no_longer_needed', label: 'No Longer Needed' },
  { value: 'created_in_error', label: 'Created in Error' },
  { value: 'other', label: 'Other' },
] as const;

// Partners whose maintenance ticket pages show the informational list of
// mechanic/maintenance rentals from the last 24 hours.
export const MECHANIC_RENTAL_REQUIRED_PARTNERS: ReadonlySet<number> = new Set([
  62, 61, 33, 46,
]);

export const MECHANIC_MEMBERSHIP_KEYWORDS = ['mechanic', 'maintenance'] as const;
